module.exports = __webpack_public_path__ + "img/Competition Winners-2.3e70fc0b.png";